export const strapiServerFetchWrapper = async <ParamType, ResponseType>(
  endpoint: string,
  params?: ParamType,
): Promise<ApiServerResponse<ResponseType>> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/strapi${endpoint}`

  const { data } = await useFetch(url, {
    body: params ? { ...params } : undefined,
    method: 'POST',
    key: url,
  })

  return data.value as ApiServerResponse<ResponseType>
}

export const strapiBrowserFetchWrapper = async <ParamType, ResponseType>(
  endpoint: string,
  params?: ParamType,
): Promise<ApiServerResponse<ResponseType>> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/strapi${endpoint}`

  const data = await $fetch(url, {
    body: params ? { ...params } : undefined,
    method: 'POST',
  })

  return data as ApiServerResponse<ResponseType>
}
